import { render, staticRenderFns } from "./QuotaSchedule.vue?vue&type=template&id=da230e2e&scoped=true"
import script from "./QuotaSchedule.vue?vue&type=script&lang=js"
export * from "./QuotaSchedule.vue?vue&type=script&lang=js"
import style0 from "./QuotaSchedule.vue?vue&type=style&index=0&id=da230e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da230e2e",
  null
  
)

export default component.exports